import{m as t}from"./chunk-HBP5N4FR.js";t();import{useRef as r,useEffect as u}from"react";function a(f,n=[]){let e=r(!0);u(()=>{e.current?e.current=!1:f()},n)}export{a};
//# sourceMappingURL=chunk-YTYNUTPN.js.map
